<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="blue">
        <h4 slot="title" class="title">Iniciar Sesión</h4>

        <p slot="description" class="description">Ingresa los credenciales</p>

        <md-field class="md-form-group" slot="inputs">
          <md-icon>call_to_action</md-icon>
          <label>Documento</label>
          <md-input
            v-on:focusout.stop="focusOutDocument()"
            v-model="documentValue"
            type="number"
          ></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Contraseña</label>
          <md-input
            v-on:keyup.enter.native="login()"
            type="password"
            v-model="password"
          ></md-input>
        </md-field>
        <md-field v-if="securityQuestion" class="md-form-group" slot="inputs">
          <md-icon>verified_user</md-icon>
          <label>{{ securityQuestion.text }}</label>
          <md-input
            v-on:keyup.enter.native="login()"
            type="password"
            v-model="securityAnswer"
          ></md-input>
        </md-field>
        <p slot="inputs" style="text-align:left; font-size:11px">
          <a @click="forgotPassword()">Olvidé mi contraseña{{ loadingFC }}</a>
        </p>
        <md-button
          slot="footer"
          :disabled="loading"
          @click="login()"
          class="md-simple md-primary md-lg"
        >
          Entrar
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import gql from "graphql-tag";
import Swal from "sweetalert2";
import { onLogin } from "../../vue-apollo.js";
import Constants from "../../constants";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      documentValue: null,
      password: null,
      loading: false,
      loadingFC: "",
      securityQuestion: null,
      currentDocumentValue: null,
      securityAnswer: null
    };
  },
  mounted() {
    if (Constants.getUserId() != null) {
      this.goToPage();
    }
  },
  methods: {
    forgotPassword() {
      this.loadingFC = "...";
      if (this.documentValue)
        this.$apollo
          .mutate({
            mutation: gql`
              mutation restorePassword($documentValue: String!) {
                restorePassword(documentValue: $documentValue)
              }
            `,
            variables: {
              documentValue: this.documentValue
            },
            update: (cache, mutationResult) => {
              this.loadingFC = "";
              var message = mutationResult.data.restorePassword;
              Swal.fire({
                title: "Notificación",
                html: message,
                confirmButtonClass: "md-button md-primary",
                buttonsStyling: false
              });
            }
          })
          .catch(error => {
            this.loadingFC = "";
            Constants.catchError(
              error,
              this.$apollo.provider.defaultClient,
              this,
              true
            );
          });
      else {
        this.loadingFC = "";
        Swal.fire({
          title: "Campo vacío",
          text: "Por favor diligencia el documento",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
      }
    },
    login() {
      if (!this.documentValue || !this.password)
        Swal.fire({
          title: "Campos vacíos",
          text: "Por favor diligencia todos los datos",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });
      else {
        this.loading = true;
        this.$apollo
          .mutate({
            mutation: gql`
              mutation loginAccount(
                $documentValue: String!
                $password: String!
                $securityQuestion: Int
                $securityAnswer: String
              ) {
                login(
                  documentValue: $documentValue
                  password: $password
                  securityQuestion: $securityQuestion
                  securityAnswer: $securityAnswer
                ) {
                  userId
                  firstName
                  secondName
                  lastName
                  secondLastName
                  documentValue
                  email
                  token
                  userType
                  hasProfile
                }
              }
            `,
            variables: {
              documentValue: this.documentValue,
              password: this.password,
              securityQuestion: this.securityQuestion
                ? this.securityQuestion.id
                : null,
              securityAnswer: this.securityAnswer
            },
            update: (cache, mutationResult) => {
              this.loading = false;
              var result = mutationResult.data.login;
              onLogin(
                this.$apollo.provider.defaultClient,
                result.token,
                result
              );
              Swal.fire({
                title: "Bienvenido " + result.firstName,
                text: "Has iniciado sesión satisfactoriamente",
                confirmButtonClass: "md-button md-primary",
                buttonsStyling: false
              }).then(() => {
                this.goToPage();
              });
            }
          })
          .catch(error => {
            this.loading = false;
            var errorMessage = null;
            if (error.graphQLErrors[0])
              errorMessage = error.graphQLErrors[0].message;
            else if (error.networkError)
              errorMessage = "Ha ocurrido un error de conexión";
            else errorMessage = "Ha ocurrido un error desde el servidor";
            Swal.fire({
              title: "¡Atención!",
              html: errorMessage,
              confirmButtonClass: "md-button md-warning",
              buttonsStyling: false
            }).then(() => {
              if (
                errorMessage.endsWith(
                  "Te invitamos a que actualices tus datos."
                )
              )
                this.$router.push("register-account");
            });
          });
      }
    },
    goToPage() {
      var purpose = this.$route.params.purpose;
      if (purpose != null && Constants.hasProfile())
        this.$router.push(purpose.replaceAll(" ", "/"));
      else if (
        !Constants.hasProfile() &&
        Constants.CLIENT == Constants.getUserType()
      )
        this.$router.push("/register-profile/");
      else {
        this.$router.push("/credit-list/");
        this.$router.go();
      }
    },
    focusOutDocument() {
      if (
        this.securityQuestion == null ||
        this.currentDocumentValue != this.documentValue
      ) {
        this.$apollo
          .query({
            query: gql`
              query getRandomSecurityQuestionByDocumentValue(
                $documentValue: String!
              ) {
                getRandomSecurityQuestionByDocumentValue(
                  documentValue: $documentValue
                ) {
                  id: secQuestionId
                  text: secQText
                }
              }
            `,
            variables: {
              documentValue: this.documentValue
            }
          })
          .then(data => {
            this.securityQuestion =
              data.data.getRandomSecurityQuestionByDocumentValue;
            this.currentDocumentValue = this.documentValue;
          })
          .catch(error => {
            this.securityQuestion = null;
            this.currentDocumentValue = this.documentValue;
          });
      }
    }
  }
};
</script>

<style></style>
